// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__1kR36","label":"Checkbox_label__TG9yw"};